export default {
  default: () => import("/home/ubuntu/adificial-content-player/node_modules/adificial-base-layer/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/home/ubuntu/adificial-content-player/node_modules/adificial-base-layer/layouts/empty.vue").then(m => m.default || m)
}